import React from 'react';
import { SmallChartSpinner } from '../Spinner';
import { EmptyChart } from './styles';

export enum MessageType {
  empty = 'empty',
  error = 'error',
}

interface Props {
  emptiness: boolean;
  error: boolean;
}

type Messages = {
  [key in MessageType]: string;
};

export const Messages: Messages = {
  [MessageType.empty]: 'No data for this period were found',
  [MessageType.error]: 'Something went wrong',
};

const getNonErrorComponent = (emptiness: boolean) => (emptiness ? Messages.empty : <SmallChartSpinner />);

export default ({ emptiness, error }: Props) => {
  const facade = error ? Messages.error : getNonErrorComponent(emptiness);
  return <EmptyChart>{facade}</EmptyChart>;
};
